import styled from "@emotion/styled";
import { Tooltip } from "@mui/material";

export const BoxIcon = styled.span`
  max-height: 16px;
  display: inline-block;
  margin-left: 4px;
  vertical-align: -2px;
`;

export const TooltipStiled = styled(Tooltip)`
  @media (max-width: ${p => p.theme.screenSizes.mdMax}) {
    display: none;
  }
`;

export const Span = styled.span`
  word-break: normal;
`;
